module.exports = __webpack_public_path__ + "img/shamaverse.9aadf66f.png";